"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var parseVersion = function parseVersion(version) {
  var _split$map = (version || '').split('.').map(function (item) {
    return +item;
  }),
      _split$map2 = (0, _slicedToArray2["default"])(_split$map, 4),
      _split$map2$ = _split$map2[0],
      major = _split$map2$ === void 0 ? 0 : _split$map2$,
      _split$map2$2 = _split$map2[1],
      minor = _split$map2$2 === void 0 ? 0 : _split$map2$2,
      _split$map2$3 = _split$map2[2],
      patch = _split$map2$3 === void 0 ? 0 : _split$map2$3,
      _split$map2$4 = _split$map2[3],
      prerelease = _split$map2$4 === void 0 ? 0 : _split$map2$4;

  return {
    major: major,
    minor: minor,
    patch: patch,
    prerelease: prerelease
  };
};

var compareResult;

(function (compareResult) {
  compareResult[compareResult["Greater"] = 1] = "Greater";
  compareResult[compareResult["Equal"] = 0] = "Equal";
  compareResult[compareResult["Smaller"] = -1] = "Smaller";
})(compareResult || (compareResult = {}));

var compareVersion = function compareVersion(versionStrA, versionStrB) {
  var versionA = parseVersion(versionStrA);
  var versionB = parseVersion(versionStrB);

  if (versionA.major > versionB.major) {
    return compareResult.Greater;
  }

  if (versionA.major < versionB.major) {
    return compareResult.Smaller;
  }

  if (versionA.minor > versionB.minor) {
    return compareResult.Greater;
  }

  if (versionA.minor < versionB.minor) {
    return compareResult.Smaller;
  }

  if (versionA.patch > versionB.patch) {
    return compareResult.Greater;
  }

  if (versionA.patch < versionB.patch) {
    return compareResult.Smaller;
  }

  if (versionA.prerelease > versionB.prerelease) {
    return compareResult.Greater;
  }

  if (versionA.prerelease < versionB.prerelease) {
    return compareResult.Smaller;
  }

  return compareResult.Equal;
};

compareVersion["default"] = compareVersion;
var _default = compareVersion;
exports["default"] = _default;
module.exports = exports["default"];